import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import BaseInfo from './BaseInfo'
import FollowUpInfo from './FollowUpInfo'
import Store from './store'
import { EXPERIENCE_SHOP_RECOMMEND_PATH } from '@constant'
import { Link } from 'react-router'

export default class extends Component {
  constructor(p) {
    super(p)
    const {
      routeParams: { id }
    } = this.props

    this.store = new Store()
    this.store.orderId = id
    this.store.getDetail()
    this.store.getHistory()
  }
  render() {
    const header = [
      <Link to={EXPERIENCE_SHOP_RECOMMEND_PATH}>体验店推荐</Link>,
      '推荐详情'
    ]
    return (
      <HeaderView title="推荐详情" header={header}>
        <div style={{ padding: 40, overflow: 'hidden' }}>
          <div style={{ width: 480, float: 'left' }}>
            <BaseInfo store={this.store} />
          </div>
          <div style={{ width: 360, float: 'right' }}>
            <FollowUpInfo store={this.store} />
          </div>
        </div>
      </HeaderView>
    )
  }
}
